<template>
  <GiftList />
</template>

<script setup lang="ts">
import GiftList from '@/pages/-lang/gift/list.vue'

definePageMeta({
  layout: 'member',
})
</script>
